module.exports = __webpack_public_path__ + "img/moon.a45ac9bb.png";